import { useMemo } from 'react'; 
import { useMutation } from '@apollo/client';
import INSTRUCTOR_UPDATE from '../mutations/INSTRUCTOR_UPDATE';

const useInstructorUpdate = () => {
    const [ patchInstructor ] = useMutation( INSTRUCTOR_UPDATE );

    const saveInstuctor = async ( saveData ) => {
        try {
            const response = await patchInstructor( { variables: { input: saveData } } );
            const success = response?.data?.patchInstructor;

            if ( success ) {
                return {
                    success: true,
                    response
                };
            } else {
                return {
                    success: false,
                    response
                };
            }
        } catch ( error ) { 
            console.error( 'Error saving instructor', error );  
            return {
                success: false,
                response: error
            };
        } 
    };

    return useMemo( () => {
        return {
            saveInstuctor         
        };
    }, [] );
};

export default useInstructorUpdate;
